import { Card } from "waapi/waap-ui/components/Card/Card.js";
import styled from "styled-components";

export const Container = styled(Card)`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${(props) => props.theme.spacing[12]};
`;
